import React from 'react';
import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom';
import { getAuthUserString } from '../helpers/auth_storage';

const AUTHED_ALLOWED_PATHS = new Set([
  '/logout',
  '/email-otp',
  '/totp-verify',
  '/totp-setup',
  '/recoverpw',
  '/reset-password',
]);

const NonAuthLayout = (props : any) => {
  const location = useLocation();
  if (getAuthUserString() && !AUTHED_ALLOWED_PATHS.has(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <React.Fragment>{props.children}</React.Fragment>
  );
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object
}

export default NonAuthLayout
